import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-payment-result26',
	templateUrl: './payment-result.component.html',
	styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent26 implements OnInit {

	constructor() {}

	ngOnInit(): void {}

}
